import { Component } from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgForOf, NgIf} from '@angular/common';
import {AppConstants} from "../../../shared/constants/app-constant";

@Component({
  selector: 'app-apply-now',
  standalone: true,
    imports: [
        ReactiveFormsModule,
        NgIf,
        NgForOf
    ],
  templateUrl: './apply-now.component.html',
  styleUrls: ['./apply-now.component.scss']
})
export class ApplyNowComponent {
    applicationForm: FormGroup;
    isSubmitted = false;
    showForm  = false;
    programs = AppConstants.courses;
    constructor(private fb: FormBuilder) {
        this.applicationForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', Validators.required],
            gender: ['', Validators.required],
            address: ['', Validators.required],
            postalCode: ['', Validators.required],
            city: ['', Validators.required],
            state: ['', Validators.required],
            institution: ['', Validators.required],
            graduationYear: ['', Validators.required],
            major: ['', Validators.required],
            company: [''],
            experience: [''],
            position: [''],
            passportUpload: [null, Validators.required],
            idUpload: [null, Validators.required],
            disclaimer: ['', Validators.required],
            signature: ['', Validators.required],
            date: ['', Validators.required],
            selectedProgram: ['', Validators.required], // To store selected programs

        });
    }
    toggleForm(): void {
        this.showForm = !this.showForm;
    }

    onSubmit() {
        if (this.applicationForm.valid) {
            this.isSubmitted = true;
            console.log('Form Submitted', this.applicationForm.value);
        }
    }
    resetForm() {
        this.applicationForm.reset();
        this.isSubmitted = false;
    }
}
